/**
 * Theme toggle is currently hidden per user request (2026-03-05).
 * The app is locked to the default (light) theme. To re-enable, restore
 * the toggle body from git history.
 */
export default function ThemeToggleFloating() {
  return null;
}
